/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = /** @type {(inputs: {}) => string} */ () => {
	return `Wir haben keine Aktivitäten in der Nähe gefunden, aber es gibt viele andere in dieser Gegend.`
};

const en_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = /** @type {(inputs: {}) => string} */ () => {
	return `We couldn't find any activities nearby, but there are plenty of others in the area.`
};

const es_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = /** @type {(inputs: {}) => string} */ () => {
	return `No encontramos ninguna actividad cerca, pero hay muchas otras en esta zona.`
};

const fr_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = /** @type {(inputs: {}) => string} */ () => {
	return `Nous n'avons pas trouvé d’activités à proximité mais il y en a beaucoup d’autres dans cette région.`
};

const it_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = /** @type {(inputs: {}) => string} */ () => {
	return `Non abbiamo trovato attività nei dintorni, ma ce ne sono molte altre in questa zona.`
};

const nl_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = /** @type {(inputs: {}) => string} */ () => {
	return `We hebben geen activiteiten in de buurt gevonden, maar er zijn veel andere in deze regio.`
};

const pt_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = /** @type {(inputs: {}) => string} */ () => {
	return `Não encontramos nenhuma atividade nas proximidades, mas há muitas outras nesta área.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_datasheet__recommendation__getyourguide__tours_not_found_without_region(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_datasheet__recommendation__getyourguide__tours_not_found_without_region", locale)
	if (locale === "de") return de_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region(inputs)
	if (locale === "en") return en_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region(inputs)
	if (locale === "es") return es_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region(inputs)
	if (locale === "fr") return fr_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region(inputs)
	if (locale === "it") return it_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region(inputs)
	if (locale === "nl") return nl_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region(inputs)
	return pt_poi_datasheet__recommendation__getyourguide__tours_not_found_without_region(inputs)
};